import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface SurveyLanguageCodeDTO {
  languageCode: string;
}

export class SurveyLanguageCode {
  readonly isSurveyLanguageCodeSurveyLanguageCode: boolean = true;

  readonly languageCode: string;

  static readonly constraints = {
    "languageCode": {
      "maxSize": 128,
      
      
      
      
    }
  }

  constructor(
  languageCode: string
  ) {
    SurveyLanguageCode.validateLanguageCode(languageCode);
    this.languageCode = languageCode;
  }

  static fromDTO(dto: SurveyLanguageCodeDTO): SurveyLanguageCode {
    const languageCode = getString(dto, "languageCode", InvalidSurveyLanguageCodeLanguageCodeError);
    return new SurveyLanguageCode(
      languageCode
    );
  }

  toDTO(): SurveyLanguageCodeDTO {
    const dto: SurveyLanguageCodeDTO = {
        languageCode: this.languageCode
    };
    return dto;
  }
  private static validateLanguageCode = (languageCode: string): void => {
    if(languageCode.length > 128) {
      throw new InvalidSurveyLanguageCodeLanguageCodeMaxSizeError(
        128,
        `Attribute languageCode is too long. Size is ${languageCode.length}. Max size is 128.`
      );
    }
      if(languageCode.trim().length === 0) {
        throw new InvalidSurveyLanguageCodeLanguageCodeNonEmptyError(
          `Attribute languageCode cannot be an empty string.`
        );
      }
  }
  
}

SurveyLanguageCode.prototype.toString = function toString(): string {
  return `SurveyLanguageCode(languageCode='${this.languageCode}')`;
};

export class InvalidSurveyLanguageCodeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLanguageCodeError";
  }
}
export class InvalidSurveyLanguageCodeLanguageCodeError extends InvalidSurveyLanguageCodeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLanguageCodeLanguageCodeError";
  }
}

export class InvalidSurveyLanguageCodeLanguageCodeMaxSizeError extends InvalidSurveyLanguageCodeLanguageCodeError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLanguageCodeLanguageCodeMaxSizeError";
  }
}

export class InvalidSurveyLanguageCodeLanguageCodeNonEmptyError extends InvalidSurveyLanguageCodeLanguageCodeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLanguageCodeLanguageCodeNonEmptyError";
  }
}
